import styled from '@emotion/styled'

import { transparentize } from 'polished'

export const StyledLoaderDiv = styled('div')`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => !theme.mode.isDark && transparentize(0.05, theme.gray.dark)};
  display: flex;
  flex-direction: column;
  color: white;
  justify-content: center;
  align-items: center;
  padding: 24px;

  button {
    margin-top: 48px;
  }

  &.light {
    background: white;
    color: ${({ theme }) => theme.gray.dark};
  }

  svg {
    display: block;
  }
`

export const StyledContentDiv = styled('div')`
  max-width: 496px;
  width: 100%;
`

export const StyledH3 = styled('h3')`
  font-size: 24px;
  font-weight: normal;
  margin: 16px 0 24px;
`

export const StyledLoaderP = styled('p')`
  font-size: 14px;
  font-weight: 300;
`
